import { OnboardingActionDispatch } from "./model";

const createdInput = (dispatch: OnboardingActionDispatch, id: string) =>
  dispatch({
    type: "CREATED_INPUT",
    id,
  });
const createdTemplate = (dispatch: OnboardingActionDispatch, id: string): void =>
  dispatch({
    type: "CREATED_TEMPLATE",
    id,
  });
const deployedTemplate = (dispatch: OnboardingActionDispatch, id: string): void =>
  dispatch({
    type: "DEPLOYED_TEMPLATE",
    id,
  });
const deleteTemplate = (dispatch: OnboardingActionDispatch, id: string): void =>
  dispatch({
    type: "DELETE_TEMPLATE",
    id,
  });
const setHidden = (dispatch: OnboardingActionDispatch, value: boolean): void =>
  dispatch({
    type: "SET_HIDDEN",
    value,
  });
const createdWorksheet = (dispatch: OnboardingActionDispatch, id: string): void =>
  dispatch({
    type: "CREATED_WORKSHEET",
    id,
  });

export { createdInput, createdTemplate, deployedTemplate, deleteTemplate, setHidden, createdWorksheet };
